import * as React from "react";
import { forwardRef } from "react";
const EyeCloseIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.45 7.90004c.3314.24853.3985.71863.15 1.05-.4158.55448-.9026 1.07376-1.4513 1.53956l.915 1.5849c.2071.3588.0842.8174-.2745 1.0246-.3587.2071-.8174.0842-1.0245-.2746l-.8385-1.4523c-.602.3663-1.2548.6723-1.9505.9022l.6951 1.3902c.1853.3705.0351.821-.3354 1.0063-.3705.1852-.821.035-1.0062-.3354l-.84985-1.6997c-.47856.0748-.97235.1142-1.47934.1142-.53099 0-1.02616-.0332-1.48905-.0948l-.84013 1.6803c-.18524.3704-.63575.5206-1.00623.3354-.37049-.1853-.52065-.6358-.33541-1.0063l.66975-1.3395c-.72159-.2254-1.34779-.5284-1.9008-.8793-.02648-.0168-.05278-.0337-.07889-.0507l-1.13534 1.1353c-.29289.2929-.76776.2929-1.060655 0-.292893-.2929-.292894-.7678 0-1.0607l1.006455-1.0064c-.49782-.4581-.912178-.92566-1.275285-1.33538l-.114974-.1296c-.275188-.30959-.247303-.78364.062284-1.05883s.783645-.24731 1.058825.06228l.09186.10343c.64999.73227 1.31424 1.48059 2.24946 2.0741.95889.6085 2.2353 1.0707 4.09813 1.0707 2.74109 0 5.02739-1.36979 6.39999-3.19996.2485-.33137.7186-.39852 1.05-.15",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(EyeCloseIcon);
export { ForwardRef as EyeCloseIcon };